import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="header">
            <div class="row2">
                <div class="col00 small">
                    <div class="heading01 type01">
                        <h1>
                            <img
                                ng-if="vm.$rootScope.company.logoFilename"
                                ng-src="{{ vm.CompanyService.getLogoImage(vm.$rootScope.company.logoFilename, vm.$rootScope.company.id, 'smallHeaderLogo') }}"
                                height="40"
                            >
                        </h1>
                        <p ng-if="vm.$rootScope.report.isEvaluableReport" class="center"
                        >{{ 'report.360° Feedback Survey' | translate }}, {{ vm.$rootScope.report.deadline }} <strong
                        >{{ vm.$rootScope.report.title }}</strong>
                        </p>
                        <p ng-if="!vm.$rootScope.report.isEvaluableReport" class="center"
                        >{{ 'report.360° Feedback Report' | translate }}, {{ vm.$rootScope.report.deadline }} <strong
                        >{{ vm.$rootScope.report.title }}</strong>
                        </p>
                        <div class="quizdata">
                          <select class="form-control"
                                  ng-model="vm.language"
                                  ng-change="vm.changeLanguage()"
                                  ng-if="vm.$rootScope.report"
                                  ng-options="language.language.toLowerCase() as vm.COMPANY_LANGUAGE_ENUM.DROPDOWN_LABELS_IN_NATIVE[language.language]
                                              for (key, language) in vm.$rootScope.company.languages">
                          </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($translate, $rootScope, $scope, $location, $stateParams, CompanyService, TranslationService, COMPANY_LANGUAGE_ENUM) {
        this.$translate = $translate;
        this.$location = $location;
        this.$stateParams = $stateParams;
        // todo: fix using $rootScope for variables
        this.$rootScope = $rootScope;
        this.CompanyService = CompanyService;
        this.TranslationService = TranslationService;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;

        const listener = $rootScope.$on('$translateChangeSuccess', () => {
            this.language = this.$translate.use();
        });
        $scope.$on('$destroy', listener);
    }

    $onInit () {
        this.language = this.$translate.use();
        if (!this.language) {
            // fallback to proposedLanguage() if use() returns undefined
            this.language = this.$translate.proposedLanguage();
        }
    }

    changeLanguage () {
        this.$location.search('lang', this.language);
        this.TranslationService.changeLanguage(this.language).then((data) => {
            this.$rootScope.$emit('evaluation:language', data);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/evaluation/report/index.js